import { memo } from "react";
import { isMyPortfolio, isNpmPackage } from "../../shared/utils";
import ProjectModal from "../ProjectModal/ProjectModal";
import "./Projects.css";

const Projects = ({ project }) => {
  function shouldCenterImage() {
    return isMyPortfolio(project.name) || isNpmPackage(project._id);
  }

  return (
    <div className="Projectpage" id="projects">
      <div className="projectsCard">
        <div className="flip-card-inner">
          <div className="flip-card-front">
            <div className="projectHeader">
              <h3>{project.name}</h3>
              <ProjectModal
                name={project.name}
                description={project.description}
                link={project.link}
                technologies={project.technologies}
                backend={project.repos[0].backendRepo}
                frontend={project.repos[0].frontendRepo}
                images={project.images}
                repo={project.repos[0]}
              />
            </div>
            <h6
              style={{
                textAlign: "left",
                padding: "0 10px",
                marginTop: "-8px",
              }}
            >
              {project.type}
            </h6>
            <div
              className="Projects"
              style={{
                backgroundImage: `url(${project.picture})`,
                backgroundPosition: shouldCenterImage ? "center" : "",
                backgroundSize: isNpmPackage(project._id)
                  ? "contain"
                  : "cover",
                backgroundRepeat: `no-repeat`,
              }}
            >
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(Projects);
